
<template>
<div class="CajitaLogin animate__animated animate__slideInDown" id="LHAlogin" v-if="LHAlogin" >
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 CajitaData CajitaData1">
        <div class="CajitadatosInicio">
            <div class="mb-3 text-center TituloPrin">

            </div>
            <div class="mb-3">
                <label class="form-label usuconLabel">Usuario:</label>
                <input type="text" id="InputUser" class="form-control rounded-pill" @keyup.enter="ValidaDatos()" @focus="QuitarStilos('InputUser')">
            </div>
            <div class="mb-3 DivContra">
                <label class="form-label usuconLabel">Contraseña:</label>
                <input type="password" id="InputPass" class="form-control rounded-pill" @keyup.enter="ValidaDatos()" @focus="QuitarStilos('InputPass')">
                <i class="bi bi-eye-fill ojito" @click="VeroNo('InputPass')" v-if="!LHAOjitoV"></i>
                <i class="bi bi-eye-slash-fill ojito" @click="VeroNo('InputPass')" v-if="LHAOjitoV"></i>
            </div>
            <div class="mb-3 DivContra text-center">
                <button @click="ValidaDatos()" class=" btn btn-primary rounded-pill ">Acceder</button>
            </div>
        </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 CajitaData CajitaData2 ">
        <img src="~@/assets/img/login/lee-blanco.png">
    </div>
</div>

<div class="Cargando" v-if="Cargando">
    <div class="wrapper">
        <div class="circle circle1"></div>
        <div class="circle circle2"></div>
        <div class="circle circle3"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <span>Cargando</span>
    </div>
</div>

<div class="CajitaDatosMenu animate__animated animate__slideInDown" v-if="LHAMenu && !LHAlogin">
    <!-- <app-menu (cierraMenu)="Login($event)" [LlegaLogin]="DataGeneral"></app-menu> -->
    <MenuVue :message="LlegaDelLogin" />
</div>

</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Swal from 'sweetalert2';
import MenuVue  from './menu.vue';

export default defineComponent({
    name: 'LoginVue',
    data(){
        let LHAOjitoV = true;
        let Cargando = true;
        let LHAlogin = true;
        let LHAMenu = false;
        let DataGeneral:Array<any> = [];
        return {LHAOjitoV,Cargando,LHAlogin, LHAMenu, DataGeneral}
    },
    mounted() {
        this.ValidaInicio();
    },
    methods: {
        async ValidaInicio(){
             let data:any = localStorage.getItem('InicioL');
            let inicio = JSON.parse(data);
            if(inicio!=null){
                // let data:any = await this.Miservicio.ValidaUser(inicio[0].Usuario,inicio[0].Contrase); 
                const formDataLogin = new URLSearchParams();
                formDataLogin.append('usu', inicio[0].Usuario);  
                formDataLogin.append('contra', inicio[0].Contrase);  
                let data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/login.php", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: 
                            formDataLogin.toString()
                        });
                // console.log(data2);
                let data = await data2.json();
                // console.log('%c 🌸 data','color:#CF8103;');
                // console.log(data);
                if(data[0].RESPONSE=="1"){
                    if(data[0].USU_ESTATUS=="1"){
                        this.LHAlogin = false;
                        this.LHAMenu = true;
                        this.DataGeneral = data[0];
                        
                        setTimeout(() => {
                            this.Cargando = false;
                            this.updateMessage(this.DataGeneral);
                        }, 1000);
                    }else{
                        Swal.fire({
                            icon: 'error',
                            title: '¡Error!',
                            text: 'Usuario desactivado.',
                            showConfirmButton: false,
                            showCloseButton:true
                        });
                        localStorage.clear();
                        this.Cargando = false;
                    }
                }else{
                    /*Swal.fire({
                    icon: 'error',
                    title: '¡Error!',
                    text: 'Usuario o contraseña incorrecta, favor de revisar e intentarlo de nuevo.',
                    showConfirmButton: false,
                    showCloseButton:true
                    });*/
                    localStorage.clear();
                    this.Cargando = false;
                }
            }else{
                this.LHAMenu = false;
                this.LHAlogin = true;
                localStorage.clear();
                setTimeout(() => {
                    this.Cargando = false;
                }, 1000);
            }
        },
        ValidaDatos(){
            this.Cargando = true;
            let input1:any =  document.getElementById('InputUser');
            let input2:any =  document.getElementById('InputPass');

            let usuario:any = input1.value;
            usuario = usuario.replaceAll(" ", "");

            let contraseña:any = input2.value;
            contraseña = contraseña.replaceAll(" ","");

            let ArrayErrores:any = [];
            let errores:any = 0;

            if(usuario==""){
            ArrayErrores.push('Falta ingresar los datos en el campo de usuario.');
            input1.classList.add('error');
            errores++;
            }
            if( contraseña==""){
            ArrayErrores.push('Falta ingresar los datos en el campo de contraseña.');
            input2.classList.add('error');
            errores++;
            }

            if(errores==0 && ArrayErrores.length==0){
            this.ValidaIngreso();
            }else{

            let htmlerror:any = '';
            htmlerror+=`<h4 style="text-align: left;">Datos faltantes:</h4>`;
            htmlerror+=`<ul style="list-style-type:square;">`;
            for (const item of ArrayErrores) {
                htmlerror+=`<li style="text-align:left;">`+item+`</li>`;
            }
            htmlerror+=`</ul>`;
            Swal.fire({
                icon: 'error',
                html: htmlerror,
                showConfirmButton: false,
                showCloseButton:true
            });
            this.Cargando = false;
            }
        },
        async ValidaIngreso(){
            this.DataGeneral = [];
            let input1:any = document.getElementById('InputUser');
            let input2:any = document.getElementById('InputPass');
            let divCajita:any =  document.getElementById('LHAlogin');

            let usuario:any = input1.value;
            usuario = usuario.replaceAll(" ", "");

            let contraseña:any = input2.value;
            contraseña = contraseña.replaceAll(" ","");

            // let data:any = await this.Miservicio.ValidaUser(usuario,contraseña);
            const formDataLogin = new URLSearchParams();
            formDataLogin.append('usu', usuario);  
            formDataLogin.append('contra', contraseña);  
            let data2:any = await fetch("https://tesis.lmspace.com.mx/php/TiendaT/LHA/login.php", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: 
                    formDataLogin.toString()
            });
            let data = await data2.json();
            if(data[0].RESPONSE=="1"){
            if(data[0].USU_ESTATUS=="1"){
                console.log(data[0].RESPONSE);
                this.DataGeneral = data[0];
                let info:any = [];
                info.push({"Usuario": data[0].USU_USERNAME, "Contrase": data[0].USU_PASSWORD});
                let Data = JSON.stringify(info);
                localStorage.setItem('InicioL', Data);
                divCajita.classList.remove('animate__slideInDown');
                divCajita.classList.add('animate__slideOutDown');
                setTimeout(() => {
                    this.LHAlogin = false;
                    this.LHAMenu = true;
                    this.Cargando = false;
                    this.updateMessage(this.DataGeneral);
                }, 1000);
            }else{
                Swal.fire({
                icon: 'error',
                title: '¡Error!',
                text: 'Usuario desactivado.',
                showConfirmButton: false,
                showCloseButton:true
                });
                localStorage.clear();
                this.Cargando = false;
            }

            }else{
            Swal.fire({
                icon: 'error',
                title: '¡Error!',
                text: 'Usuario o contraseña incorrecta, favor de revisar e intentarlo de nuevo.',
                showConfirmButton: false,
                showCloseButton:true
            });
            localStorage.clear();
            this.Cargando = false;
            }
        },
        QuitarStilos(input:string){
            let inputX:any = document.getElementById(input);
            inputX.classList.remove('error');
        },
        VeroNo(id:string){
            this.LHAOjitoV= !this.LHAOjitoV;
            let input:any = document.getElementById(id);
            if(input.type==="password"){
            input.type = "text";
            }else{
            input.type = "password";
            }
        }, 
        Login(resp:boolean){
            localStorage.clear();
            this.LHAlogin = resp;
            this.LHAMenu = false;
        }
    }, 
    components:{
        MenuVue
    },
    setup() {
    // const LlegaDelLogin = ref('Mensaje del componente padre para el hijo');
    const LlegaDelLogin = ref({});

    const updateMessage = (DataGeneral:any) => {
      LlegaDelLogin.value = DataGeneral;
    };
    return {
      LlegaDelLogin,
      updateMessage
    };
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
    font-family: 'ZonaProBold';
    src: url(~@/assets/fonts/ZonaPro-Bold.ttf);
}

@font-face {
    font-family: 'ZonaProSemiBold';
    src: url(~@/assets/fonts/ZonaPro-SemiBold.ttf);
}

@font-face {
    font-family: 'ZonaProItalic';
    src: url(~@/assets/fonts/ZonaPro-RegularItalic.ttf);
}

@font-face {
    font-family: 'ZonaPro';
    src: url(~@/assets/fonts/ZonaPro-Regular.ttf);
}

.CajitaLogin {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    /*background-image: url(https://tesis.lmspace.com.mx/angular/assets/img/login/Lee-cat-fondo3.png);*/
    background-image: url(~@/assets/img/login/Lee-cat-fondo3.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: bottom;
    overflow: auto;
}

.CajitaLogin::-webkit-scrollbar {
    width: 8px;
    /* Tamaño del scroll en vertical */
    height: 8px;
    /* Tamaño del scroll en horizontal */
    /*Ocultar scroll 
    display: none;*/
}

.CajitaLogin::-webkit-scrollbar-thumb {
    /* thumb */
    background: #585E99;
    border-radius: 50px;
    height: 50px;
}

.CajitaLogin::-webkit-scrollbar-track {
    /* track */
    background: white;
    border-radius: 50px;
}

.CajitaData {
    padding: 2em;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    /**/font-family: 'ZonaPro';
}

.CajitadatosInicio {
    width: 80%;
    height: 50%;
    background-color: rgba( #fff9f9, 0.55);
    border: solid 1px white;
    border-radius: .8rem;
    padding: 2em;
}

.TituloPrin {
    /**/font-family: 'ZonaProBold';
    font-size: calc(1em + 3vw) !important;
    color: white;
    -webkit-text-stroke: black 3px;
    text-shadow: 2px 1px #000, -2px 1px #000, 1px 2px #000, 1px -2px #000, 1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000;
}

.usuconLabel {
    /**/font-family: 'ZonaProSemiBold';
    font-size: 1.2rem;
    color: #516896;
}

.DivContra {
    position: relative;
}

.error {
    border-color: #dc3545;
}

.ojito {
    position: absolute;
    bottom: 0.4rem;
    right: 1rem;
    cursor: pointer;
    color: #516896;
}


/*-------------------------------Login---------------------------------------*/
.Cargando {
    background-color: rgba( #A381AA, 0.85);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
}

.wrapper {
    width: 200px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.circle {
    width: 20px;
    height: 20px;
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
    left: 15%;
    transform-origin: 50%;
    animation: circle .5s alternate infinite ease;
}

.circle1 {
    background-color: rgba( #E5A5DF, 1.0);
}

.circle2 {
    background-color: #CEB2EE;
}

.circle3 {
    background-color: #B3C4F9;
}

@keyframes circle {
    0% {
        top: 60px;
        height: 5px;
        border-radius: 50px 50px 25px 25px;
        transform: scaleX(1.7);
    }
    40% {
        height: 20px;
        border-radius: 50%;
        transform: scaleX(1);
    }
    100% {
        top: 0%;
    }
}

.circle:nth-child(2) {
    left: 45%;
    animation-delay: .2s;
}

.circle:nth-child(3) {
    left: auto;
    right: 15%;
    animation-delay: .3s;
}

.shadow {
    width: 20px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    top: 62px;
    transform-origin: 50%;
    z-index: -1;
    left: 15%;
    filter: blur(1px);
    animation: shadow .5s alternate infinite ease;
}

@keyframes shadow {
    0% {
        transform: scaleX(1.5);
    }
    40% {
        transform: scaleX(1);
        opacity: .7;
    }
    100% {
        transform: scaleX(.2);
        opacity: .4;
    }
}

.shadow:nth-child(4) {
    left: 45%;
    animation-delay: .2s
}

.shadow:nth-child(5) {
    left: auto;
    right: 15%;
    animation-delay: .3s;
}

.wrapper span {
    position: absolute;
    top: 75px;
    /**/font-family: 'ZonaProBold';
    font-size: 2rem;
    letter-spacing: 12px;
    color: #fff;
    text-shadow: 4px 3px 0 #7A51A1;
    left: 15%;
    letter-spacing: 8px;
    left: -4%;
    top: 80px;
}
/*---------------------------------------------------------------------------*/

@media screen and (max-width: 991px) {
    .CajitaData1 {
        order: 2;
    }
    .CajitaData2 {
        order: 1;
    }
    .CajitaData {
        padding: 1em;
    }
    .CajitaData2>img {
        width: 50%;
    }
    .CajitaLogin {
        align-content: flex-start;
        align-items: flex-start;
    }
}
</style>
